import React from 'react';
import { Navigate } from 'react-router-dom';
import TradingRulesDashboard from '../TradingRulesDashboard';
import { DASHBOARD_ROUTES } from '../../constants/dashboardRoutes';
import useIsMobile from '../../hooks/useIsMobile';

/** Trading rules health dashboard embedded inside DashboardShell. */
export default function DashboardHealthPage() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <Navigate to={DASHBOARD_ROUTES.overview} replace state={{ portfolioTab: 'health' }} />;
  }

  return (
    <TradingRulesDashboard
      hideHeader
      hideDashboardHeader={false}
      hideAccountDropdown
      dashboardTitle="Account Health"
      hideSnapshotTradingRulesButton
    />
  );
}
